<template>
  <div class="whatsaap-modern">
    <NavBar />

    <div class="whatsaap-container">
      <!-- Header Section -->
      <div class="whatsapp-header">
        <div class="header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-cog title-icon"></i>
              Configuração WhatsApp {{ string_type }}
            </h1>

            <p class="page-subtitle">
              Configure o WhatsApp responsável pelo envio de mensagens
              relacionadas a {{ string_type }} dos residentes.
            </p>
          </div>
        </div>
      </div>

      <div class="container-modern">
        <WhatsAppConnect :type="type" :rest_home_id="rest_home_id" />
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar.vue";

import WhatsAppConnect from "./WhatsAppConnect.vue";

import routes from "../../routes";

import { userData } from "../../lib/functions";

export default {
  name: "WhatsAppSettings",

  props: {
    type: String,
  },

  components: {
    NavBar,
    WhatsAppConnect,
  },

  data() {
    return {
      rest_home_id: null,

      string_type: "",
    };
  },

  async created() {
    let { user } = userData();

    this.rest_home_id = user.rest_home_id;

    if (this.type == "REPORT_CARE") {
      this.string_type = "Cuidados";
    } else {
      this.string_type = "Medicamentos";
    }
  },

  methods: {
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style scoped>
.whatsaap-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.whatsaap-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.whatsapp-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.container-modern {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(30, 41, 59, 0.06);
  padding: 5px 24px 1px 15px;
  margin: 25px 25px;
  display: flex;
  gap: 25px;
}

@media (max-width: 1024px) {
  .header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }
  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .whatsaap-container {
    padding: 0 16px;
  }
  .whatsapp-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }
  .header-content {
    padding: 0 16px;
  }
  .page-title {
    font-size: 24px;
  }
  .page-subtitle {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }
  .title-icon {
    margin-right: 0;
  }
}
</style>